(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["td-reviews-carousel-okendo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-reviews-carousel-okendo')) {
    class TdReviewsCarouselOkendo extends HTMLElement {
      constructor() {
        super();
        this.productId = this.dataset.productId || '';
        this.okendoUserId = this.dataset.okendoUserId || '';
        this.settings = {};
        try {
          this.settings = JSON.parse(this.dataset.settings || '{}');
        } catch (e) {
          console.warn('TdReviewsCarouselOkendo: Invalid settings', e);
        }
        this.limit = Math.min(10, Math.max(3, this.settings.limit || 5));
        this.qualityFilter = this.settings.qualityFilter || 'balanced';
      }

      connectedCallback() {
        if (!this.productId || !this.okendoUserId) {
          this.showState('error');
          return;
        }
        this.attachViewAllListener();
        this.fetchReviews();
      }

      /**
       * Attaches click listener to "View all reviews" link for smooth scroll to reviews section.
       */
      attachViewAllListener() {
        const wrapper = this.closest('.td-reviews-carousel-okendo');
        const cta = wrapper?.querySelector('[data-view-all]');
        if (!cta) return;
        cta.addEventListener('click', (e) => {
          const el = document.querySelector('#product-okendo-reviews');
          if (el) {
            e.preventDefault();
            el.scrollIntoView({ behavior: 'smooth' });
          }
        });
      }

            /**
       * Returns Okendo API orderBy param based on quality filter.
       * Balanced/trust_focused: helpful desc; all: date desc.
       */
       getOrderBy() {
        const map = {
          balanced: 'helpful%20desc',
          trust_focused: 'helpful%20desc',
          all: 'date%20desc'
        };
        return map[this.qualityFilter] || map.balanced;
      }

      /**
       * Applies client-side quality filter to reviews array.
       * Returns filtered array (order preserved from API).
       */
      filterReviews(reviews) {
        if (!Array.isArray(reviews) || reviews.length === 0) return [];
        const f = this.qualityFilter;
        if (f === 'all') return reviews;
        return reviews.filter((r) => {
          const verified = !!r.reviewer?.isVerified;
          const rating = r.rating || 0;
          const incentivized = !!r.isIncentivized;
          if (f === 'balanced') return verified && rating >= 4 && !incentivized;
          if (f === 'trust_focused') return verified && rating >= 4;
          return true;
        });
      }

      /**
       * Shows a state of the component.
       * @param {string} state - State to show
       */
      showState(state) {
        this.dataset.state = state;
      }

      /**
       * Formats a date string to a human-readable date ago.
       * @param {string} dateStr - Date string to format
       * @returns {string} Formatted date ago
       */
      formatDateAgo(dateStr) {
        const date = new Date(dateStr);
        const now = new Date();
        const diffMs = now - date;
        const diffMonths = Math.floor(diffMs / (1000 * 60 * 60 * 24 * 30));
        const diffYears = Math.floor(diffMs / (1000 * 60 * 60 * 24 * 365));
        if (diffYears >= 1) return `${diffYears} YEAR${diffYears > 1 ? 'S' : ''} AGO`;
        if (diffMonths >= 1) return `${diffMonths} MONTH${diffMonths > 1 ? 'S' : ''} AGO`;
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
        if (diffDays >= 1) return `${diffDays} DAY${diffDays > 1 ? 'S' : ''} AGO`;
        return 'TODAY';
      }

      /**
       * Escapes HTML characters in a string.
       * @param {string} str - String to escape
       * @returns {string} Escaped string
       */
      escapeHtml(str) {
        if (!str) return '';
        const div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
      }

      /**
       * Truncates text to a maximum number of words, appending ellipsis if truncated.
       * @param {string} str - Text to truncate
       * @param {number} maxWords - Maximum words to show (default 30)
       */
      truncateWords(str, maxWords) {
        if (!str) return '';
        const words = str.trim().split(/\s+/);
        if (words.length <= maxWords) return str;
        return words.slice(0, maxWords).join(' ') + '…';
      }

      /**
       * Fetches reviews from Okendo API and renders the carousel.
       */
      async fetchReviews() {
        const orderBy = this.getOrderBy();
        const url = `https://api.okendo.io/v1/stores/${this.okendoUserId}/products/shopify-${this.productId}/reviews?limit=25&orderBy=${orderBy}`;
        try {
          const res = await fetch(url);
          if (!res.ok) {
            throw new Error(`HTTP ${res.status}`);
          }
          const data = await res.json();
          const raw = data?.reviews || [];
          const filtered = this.filterReviews(raw);
          const reviews = filtered.slice(0, this.limit);
          if (reviews.length === 0) {
            this.showState('empty');
            return;
          }
          this.renderCarousel(reviews);
        } catch (err) {
          console.warn('TdReviewsCarouselOkendo: Failed to fetch reviews', err);
          this.showState('error');
        }
      }

      /**
       * Renders the carousel with the reviews.
       * @param {Array} reviews - Array of reviews to render
       */
      renderCarousel(reviews) {
        this.showState('carousel');
        const carouselEl = this.querySelector('[data-carousel]');
        if (!carouselEl) return;

        const opts = {
          centeredSlides: true,
          loop: reviews.length > 1,
          slidesPerView: 'auto',
          spaceBetween: 40,
          watchOverflow: true,
          breakpoints: { 769: { slidesPerView: 1.44, centeredSlides: false } }
        };
        if (this.settings.autoscroll) {
          opts.autoplay = { delay: (this.settings.autoscrollSpeed || 5) * 1000 };
        }
        if (this.settings.showNav) {
          opts.navigation = {
            nextEl: this.settings.navNext || '.swiper-square-arrow-next',
            prevEl: this.settings.navPrev || '.swiper-square-arrow-prev'
          };
        }

        const slidesHtml = reviews.map((r) => {
          const rating = r.rating || 0;
          const title = this.escapeHtml(r.title || '');
          const body = this.truncateWords(this.escapeHtml(r.body || ''), 40);
          const name = this.escapeHtml(r.reviewer?.displayName || 'Customer');
          const verified = r.reviewer?.isVerified;
          const dateStr = this.formatDateAgo(r.dateCreated || '');
          return `
            <div class="swiper-slide td-reviews-carousel-okendo__slide" data-swiper-slide>
              <div class="td-reviews-carousel-okendo__slide-inner">
                <div class="td-reviews-carousel-okendo__card-top">
                  <span class="td-reviews-carousel-okendo__stars" role="img" aria-label="${rating} out of 5 stars" style="--rating: ${rating}"></span>
                  <span class="td-reviews-carousel-okendo__date">${dateStr}</span>
                </div>
                ${title ? `<p class="td-reviews-carousel-okendo__title">${title}</p>` : ''}
                ${body ? `<p class="td-reviews-carousel-okendo__body">${body}</p>` : ''}
                <p class="td-reviews-carousel-okendo__reviewer-container">
                  <span class="td-reviews-carousel-okendo__reviewer">${name}</span>
                  ${verified ? '<span class="td-reviews-carousel-okendo__verified">Verified Buyer</span>' : ''}
                </p>
              </div>
            </div>
          `;
        }).join('');

        carouselEl.innerHTML = `
          <div class="swiper td-reviews-carousel-okendo__swiper" data-swiper>
            <div class="swiper-wrapper td-swiper-wrapper">
              ${slidesHtml}
            </div>
          </div>
        `;

        const containerId = this.dataset.containerId || '';
        const wrapper = containerId ? document.getElementById(containerId) : this.closest('.td-reviews-carousel-okendo');
        const navWrap = wrapper?.querySelector('.td-reviews-carousel-okendo__nav');
        if (navWrap && this.settings.showNav && reviews.length > 1) {
          navWrap.classList.remove('td-reviews-carousel-okendo__nav--hidden');
        }

        this.initSwiper(carouselEl, opts);
      }

      /**
       * Initializes the Swiper instance.
       * @param {Element} container - Container element
       * @param {Object} opts - Swiper options
       */
      initSwiper(container, opts) {
        const swiperEl = container.querySelector('[data-swiper]');
        if (!swiperEl) return;

        const init = () => {
          if (window.Swiper) {
            new window.Swiper(swiperEl, opts);
          }
        };

        if (document.readyState === 'complete') {
          init();
        } else {
          window.addEventListener('load', init);
        }
      }
    }
    customElements.define('td-reviews-carousel-okendo', TdReviewsCarouselOkendo);
  }
  } catch(e) { console.error(e); }
})();

})();
